// extracted by mini-css-extract-plugin
module.exports = {"project":"projects-module--project--3V3lV","image":"projects-module--image--32zew","display":"projects-module--display--230mI","styles":"projects-module--styles--kmwuY"};